module.exports = __webpack_public_path__ + "static/media/groceries_img.e472c19e.png";